


























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Observable } from 'rxjs'
import { EventUtils } from '@/utils'
import 'animate.css'
import { PostMessageProcessor } from '../utils/PostMessageProcessor';
import { AppSettings } from '@/appSettings'
import defaultWeblinkPreview from '@/assets/images/avatar-default.png'
import CloseSVG from '@/assets/images/Close.svg'
import LoadingScreen from '@/components/LoadingScreen'

@Component({
  components: {
    LoadingScreen,
  }
})
export default class WebView extends Vue {
  webview: HTMLDivElement
  overlay: HTMLDivElement
  iframe: HTMLIFrameElement
  close = CloseSVG

  weblinkUri: string = ''
  weblinkTitle: string = ''
  weblinkPreviewUri: string = ''

  overrideCloseWebview: boolean

  isOpening: boolean = false
  isWebviewLoading: boolean = true
  shouldShowWebview: boolean = false
  animateLoading: boolean = false

  mounted() {
    this.webview = document.querySelector('#webview') as HTMLDivElement
    this.overlay = document.querySelector('.overlay') as HTMLDivElement
    this.iframe = document.querySelector('#webview-iframe') as HTMLIFrameElement

    const openSubscription = {
      next: (weblink) => {
        if (weblink) {
          this.weblinkUri = weblink.uri
          this.weblinkTitle = weblink.title
          this.weblinkPreviewUri = weblink.image || defaultWeblinkPreview
          this.openWebView(weblink.target)
        } else {
          this.overrideCloseWebview = true
        }
      },
      error: (error) => {
        console.log(error)
      },
      complete: () => {
        console.log('finished')
      },
    }
    const closeSubscription = {
      next: () => {
        this.overrideCloseWebview = false
        this.closeWebView()
      },
      error: (error) => {
        console.log(error)
      },
      complete: () => {
        console.log('finished')
      },
    }

    EventUtils.subscribeWebview(openSubscription, closeSubscription)
  }

  openWebView(target: string) {
    this.isOpening = true
    this.handleTarget(target)
    this.webViewIn()

    this.isWebviewLoading = true

    Observable.merge(
      Observable.fromEvent(this.webview, 'animationend'),
      Observable.fromEvent(this.webview, 'webkitAnimationEnd')
    )
      .first()
      .subscribe(() => {
        this.isOpening = false
        this.iframe.src = this.weblinkUri
        this.animateLoading = true
        Observable.fromEvent(this.iframe, 'load')
          .first()
          .subscribe(() => {
            this.isWebviewLoading = false
          })
      })
  }

  async handleTarget(target) {
    this.webview.style.height =
      target === 'self' ? '90%' : target === 'selfTall' ? '70%' : '50%'
  }

  async webViewIn() {
    this.webview.classList.remove('slideOutDown')
    this.webview.classList.add('slideInUp')

    this.overlay.classList.remove('fadeOut')
    this.overlay.classList.add('fadeIn')

    this.shouldShowWebview = true
  }

  closeWebView() {
    if (this.isOpening) {
      return
    }
    if (this.overrideCloseWebview) {
      PostMessageProcessor.send({code: AppSettings.get('CLOSE_WEBVIEW_CODE')}, this.iframe, this.weblinkUri)

      return
    }
    Observable.merge(
      Observable.fromEvent(this.webview, 'animationend'),
      Observable.fromEvent(this.webview, 'webkitAnimationEnd')
    )
      .first()
      .subscribe(() => {

        this.shouldShowWebview = false
        this.iframe.src = ''
      })

    this.webview.classList.remove('slideInUp')
    this.webview.classList.add('slideOutDown')

    this.overlay.classList.remove('fadeIn')
    this.overlay.classList.add('fadeOut')
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/WebView.vue